<template>
  <div style="">
    <h3 class="dashboard-header">Personal Bests</h3>
    <hr>
    <!-- {{ personalBests }} -->

    <div v-for="pb in personalBests" :key="pb.id">
      <h3>{{ pb.race_type }}</h3>
      <div>
        <h3 style="font-weight: 600;"><span v-if="pb.time_hours">{{ pb.time_hours }}:</span><span v-if="!pb.time_hours">00:</span>{{ pb.time_minutes | twoDigits }}:{{ pb.time_seconds | singleDecimalSeconds }}</h3>
      </div>
      <p style="margin-bottom: 0;">{{ pb.race_name }}</p>
      <div>
        <small>{{ pb.date }}</small>
      </div>
      <hr>
    </div>

  </div>
</template>

<script>
  import axios from 'axios'

  export default {
    props: ['user'],
    data () {
      return {
        user: null,
        personalBests: null,
      }
    },
    created () {
      // this.getUserProfile();
      this.getPBs();
    },
    methods: {
      getUserProfile () {
        this.$store.dispatch('getUser').then(() => { // Lecture 360
          this.user = this.$store.getters.user
          console.log(this.$store.getters.user)
          this.getPBs();
        })
      },
      getPBs () {
        // https://support.clickmeter.com/hc/en-us/articles/211032666-URL-parameters-How-to-pass-it-to-the-destination-URL
        axios.get('/api/pastraces/?personal_best=true&user='.concat(this.user.id.toString()))
          .then(res => {
            console.log(res)
            this.personalBests = res.data
            console.log(this.personalBests)

            // https://flaviocopes.com/how-to-sort-array-of-objects-by-property-javascript/
            // https://stackoverflow.com/questions/2466356/javascript-object-list-sorting-by-object-property
            // Sort the personal bests so the higher distances show first
            this.personalBests = this.personalBests.sort((a, b) => (a.distance < b.distance) ? 1 : -1)
          })
          .catch(error => console.log(error))
      },
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/myrundash/dashboard/PersonalBests.vue